<template>
    <component v-bind="$attrs" :is="component" :disabled="disabled" :element="element" :size="size">
        <slot />
    </component>
</template>

<script>
import ButtonPrimary from '@/components/ButtonPrimary.vue';
import ButtonWhite from '@/components/ButtonWhite.vue';
import ButtonDanger from '@/components/ButtonDanger.vue';

export default {
    name: 'AppButton',
    components: {
        primary: ButtonPrimary,
        white: ButtonWhite,
        danger: ButtonDanger,
    },
    props: {
        desiredAction: {
            type: [Boolean, String],
            default: false,
        },
        element: {
            type: String,
            default: 'a',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'md',
            validator(value) {
                // The value must match one of these strings
                return ['sm', 'md', 'lg', 'xl', 'xxl'].includes(value);
            },
        },
    },
    computed: {
        component() {
            if (this.desiredAction === 'danger') {
                return 'danger';
            }

            return this.desiredAction ? 'primary' : 'white';
        },
    },
};
</script>
